import { Direction } from "@enums/direction";

export function descendingComparator<T>(a: T, b: T, orderBy?: keyof T) {
  if (!orderBy) return 0;

  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

export function getComparator<T>(
  order: Direction,
  orderBy?: keyof T,
): (a: T, b: T) => number {
  return order === Direction.Desc
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}
